import { useEffect, useRef } from 'react';

/**
 * Retorna uma ref `{ current: boolean }` que indica se o componente
 * ainda está montado. Use antes de chamar setState dentro de awaits
 * para evitar warnings e atualizações em componentes desmontados.
 *
 * Exemplo:
 *   const mounted = useIsMounted();
 *   const r = await api.get(...);
 *   if (!mounted.current) return;
 *   setData(r.data);
 */
export default function useIsMounted() {
  const ref = useRef(true);
  useEffect(() => {
    ref.current = true;
    return () => { ref.current = false; };
  }, []);
  return ref;
}
